"use client";
import PropertyCarousel2 from "../components/PropertyCarousel2";
import { SideItem3 } from "./Sale3";
import { mockRules } from "../../design1/ShortletPage1";
import { bookingInformation } from "../../design2/Shortlet2";
import { utilities } from "../../design1/PropertyPage1";
import { PropertyUtilities3 } from "../../../constants/utilitiesIcons";
import { AccordionVariant } from "./Sale3";
import { ParentCard } from "../../design1/PropertyPage1";
import { generateSliderImages } from "../components/PropertyCarousel2";
import { KeyValueDisplay } from "./Sale3";
import { mockProperties } from "../../../constants/mockProperties";

import React from "react";
import Example from "../../design1/components/Map";

import { members } from "../../design1/components";

import { useParams } from "next/navigation";
import { findPropertyById } from "../../../constants/mockProperties";
import { PropertyCard } from "../../design2/Rent2";
import StyledWraper from "../components/StyledWraper";
import { ShowMoreText } from "../../design1/About1";
import { mockDesc } from "../../design2/Sale2";

const Shortlet3 = () => {
  const search = useParams();
  const { id } = search;
  const toNum = parseInt(id as string);
  const property = findPropertyById(toNum)!;
  const images = generateSliderImages(mockProperties.forRent[0].images);
  return (
    <section>
      <div className=" pb-10 pt-5">
        <PropertyCarousel2
          images={[
            ...images,
            {
              url: "https://www.youtube.com/watch?v=m3E72ZJ54_k",
              type: "video",
            },
          ]}
        />

        <div className="wrapper">
          <PropertyCard
            quote={property.quote}
            variant
            type={property.type}
            title={property.title}
            price={property.price}
            propertyId="6454545"
            address={property.address}
            beforePrice={property?.beforePrice}
            discount={property.discount}
            quotePrice={property.quotePrice}
            priceType={property.priceType}
          />
          <div className="grid-container mt-12">
            <div className="first flex flex-col gap-4">
              {" "}
              <StyledWraper>
                <ParentCard header="Property Brief">
                  <ShowMoreText maxLength={300} text={mockDesc} />
                </ParentCard>
              </StyledWraper>
              <StyledWraper>
                <ParentCard header="Rules">
                  <PropertyUtilities3 list="rules" selectedItems={mockRules} />
                </ParentCard>
              </StyledWraper>
              <StyledWraper>
                <ParentCard header="New Ocuupants">
                  <KeyValueDisplay money data={initialPaymentDetails} />
                </ParentCard>
              </StyledWraper>
              <StyledWraper>
                <ParentCard header="Renewal Ocuupants">
                  <KeyValueDisplay money data={renewalTenantDetails} />
                </ParentCard>
              </StyledWraper>
              <StyledWraper>
                <ParentCard header="Facilities">
                  <PropertyUtilities3 selectedItems={utilities} />
                </ParentCard>
              </StyledWraper>
              <StyledWraper>
                <ParentCard header="Booking Information">
                  <KeyValueDisplay data={bookingInformation} />
                </ParentCard>
              </StyledWraper>
              <StyledWraper>
                <ParentCard header="Terms & Conditions">
                  <AccordionVariant
                    data={{
                      questions: [
                        {
                          question: "Refund Policy",
                          answer: "You can request a refund within 7 days.",
                        },
                        {
                          question: "Property Facility",
                          answer: "Facilities include WiFi, Pool, and Gym.",
                        },
                        {
                          question: "Other Rules",
                          answer: "No smoking inside the premises.",
                        },
                      ],
                    }}
                  />
                </ParentCard>
              </StyledWraper>
              <StyledWraper>
                <ParentCard header="Location">
                  <Example coordinates={[6.4913408, 3.391488]} />
                </ParentCard>
              </StyledWraper>
            </div>
            <SideItem3
              properties={mockProperties.forRent}
              members={members[0]}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
export default Shortlet3;

// const propertyDetails: Record<string, string | number> = {
//   "Property Title": "Obolongo Estate",
//   Category: "Residential",
//   Preference: "Newly Built",
//   "Unit Type": "Block Of Flat",
//   "Unit Sub Type": "Flat",
//   "Total Area": "4300sqm",
//   Bathroom: 20,
//   Bedroom: 20,
//   Toilet: 20,
//   "Unit Name/Number": 20,
//   "Total Unit": 20,
//   "Available Unit": 20,
//   "Total Views": 20,
//   Bookmarks: 20,
//   "Added Date": "20/02/2025",
//   "Last Updated": "20/02/2025",
// };

const initialPaymentDetails: Record<string, number> = {
  "Price Per Night": 3300300,

  "Refundable Caution Fee": 3300300,
  "First Payment": 3000000,
  "Total Payment": 3000000,
};

const renewalTenantDetails: Record<string, number> = {
  "Cost Per Night": 3300300,
  "Subsequential Payment": 3300300,
};
